import { useState } from "react";
import { toast } from "sonner";
import { useEnroll } from "../hooks/useEnroll";
import { useContent } from "../hooks/useContent"; // NEW
import { Button } from "./ui/Button";
import { Input, Textarea } from "./ui";

const EnrollModal = ({ open, onClose }) => {
    const enroll = useEnroll();
    const { data: content } = useContent();               // NEW
    const courses = content?.courses || [];               // NEW

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        age: "",
        course: "",
        message: "",
    });

    if (!open) return null;

    const handleChange = (field) => (e) => {
        setFormData((prev) => ({ ...prev, [field]: e.target.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await enroll.mutateAsync({
                ...formData,
                age: formData.age ? Number(formData.age) : undefined,
            });
            toast.success("Enrollment submitted! We will contact you soon.");
            setFormData({
                name: "",
                phone: "",
                email: "",
                age: "",
                course: "",
                message: "",
            });
            onClose?.();
        } catch {
            toast.error("Failed to submit enrollment. Please try again.");
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
            <div className="relative max-h-[90vh] w-full max-w-md overflow-y-auto rounded-xl bg-background p-6">
                <Button
                    onClick={onClose}
                    className="absolute right-4 top-4 text-2xl text-cream/80 hover:text-gold"
                    aria-label="Close"
                >
                    ×
                </Button>

                <h2 className="text-2xl font-display font-bold mb-4 text-foreground">
                    Enroll Now
                </h2>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <Input
                        placeholder="Full Name"
                        required
                        value={formData.name}
                        onChange={handleChange("name")}
                    />
                    <Input
                        placeholder="Phone Number"
                        required
                        value={formData.phone}
                        onChange={handleChange("phone")}
                    />
                    <Input
                        type="email"
                        placeholder="Email (optional)"
                        value={formData.email}
                        onChange={handleChange("email")}
                    />
                    <Input
                        type="number"
                        placeholder="Age"
                        value={formData.age}
                        onChange={handleChange("age")}
                    />

                    <label className="block text-sm font-medium text-foreground">
                        Preferred Course
                        <select
                            className="mt-1 block w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-accent"
                            required
                            value={formData.course}
                            onChange={handleChange("course")}
                        >
                            <option value="">Select course</option>
                            {courses.map((course) => (
                                <option key={course.name} value={course.name}>
                                    {course.name}
                                </option>
                            ))}
                            <option value="Other">Other</option>
                        </select>
                    </label>

                    <Textarea
                        rows={3}
                        placeholder="Anything else we should know? (optional)"
                        value={formData.message}
                        onChange={handleChange("message")}
                    />
                    <Button
                        type="submit"
                        variant="gold"
                        className="w-full"
                        disabled={enroll.isLoading}
                    >
                        {enroll.isLoading ? "Submitting..." : "Submit Enrollment"}
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default EnrollModal;